module.exports = __webpack_public_path__ + "img/text-subject.3c9cbc04.svg";